var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreeringFluildLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    width: "50px",
    height: "50px",
    enableBackground: "new 0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M817.3,299.6c57.5,0,104.2-42.9,104.2-95.9c0-11.2-2.1-22-5.9-32L817.3,12L716.8,171.8c-3.8,10-5.9,20.7-5.9,32C710.9,256.7,759.7,299.6,817.3,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M934.9,292.4c-21.3,33.8-53.3,58.2-90.4,66.7c11.3,26.9,19.2,55.6,24.1,85.3c-0.2,0-0.3,0-0.5,0c-186.5,0-228.1-105.7-368.6-105.8c-133.5,0-185.4,96.6-368.1,104.9C161.6,264.3,314.9,127.7,500,127.7c60.1,0,116.7,14.8,167.1,40.3c1.4-10.1,3.5-20,6.5-29.4l39.5-77.9C648.9,28.3,576.6,10,500,10C235.4,10,20.9,227.9,20.9,496.6C20.9,765.4,235.4,990,500,990c264.6,0,479.1-224.6,479.1-493.4C979.1,423.7,963.2,354.5,934.9,292.4z M423.1,803.3c0,21.4-5.1,41.4-14.6,58.6c-143.8-36.7-254.3-157.7-277.8-308.4h181.5c62.5,0,110.9,64.3,110.9,127.5V803.3z M500.3,554.7c-43,0-77.9-34.8-77.9-77.8c0-43,34.9-77.8,77.9-77.8c43,0,77.9,34.8,77.9,77.8C578.3,519.9,543.4,554.7,500.3,554.7z M579.8,864.9c-13.3-17.8-21.8-38.9-21.8-61.6V680.9c0-63.2,58.9-127.5,121.4-127.5h190C845.1,708.2,729.3,831.9,579.8,864.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreeringFluildLevel);
export default __webpack_public_path__ + "static/media/StreeringFluildLevel.e71e71d00c1d0e564bcfd618bdf1849e.svg";
export { ForwardRef as ReactComponent };